// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Transaction history'"></sub-header>

  <report-filters config="\$ctrl.filterConfig" params="\$ctrl.filters"></report-filters>

  <div ng-if="\$ctrl.tableConfig.data.length > 0">
    <table class="table" ng-table="\$ctrl.tableConfig">
      <tbody class="appraisal-details">
        <tr ng-repeat-start="item in \$data"
            class="table__row--clickable"
            ng-click="\$ctrl.itemClicked({action: item, idx: \$index}, \$event)"
            ng-class="{'selected': \$ctrl.selectedActionId === \$index}">
          <td data-title="'No'">
            {{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}
          </td>
          <td data-title="'Date and time'">{{item.registrationDate | prettyDateTime}}</td>
          <td data-title="'User initiating'">{{item.initiatingUserName}}</td>
          <td data-title="'Target user'">{{item.targetUserName}}</td>
          <td data-title="'Transaction type'">{{item.actionType | prettyEnum}}</td>
          <td data-title="'Remarks'">{{item.remarks}}</td>
          <td data-title="'Status'">{{item.status | prettyEnum}}</td>
          <td data-title="'Debit (Amount Received)'">{{item.debitAmount | nxCurrency}}</td>
          <td data-title="'Credit (Amount Paid)'">{{item.creditAmount | nxCurrency}}</td>
        </tr>
        <tr ng-repeat-end class="table__row--not-hoverable">
          <td colspan="100%">
            <div class="toggleable-panel-wrapper"
                 ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedActionId === \$index}">
              <inline-panel on-hide="\$ctrl.hideInlinePanel()">
                <div class="inline-panel__list">
                  <div class="inline-panel__container" ng-repeat="detail in item.details">
                    <label class="inline-panel__label">{{detail.label}}:</label>
                    <p class="inline-panel__value">{{detail.value}}</p>
                  </div>
                </div>
                <div class="inline-panel-footer">
                  <button
                    ng-if="\$ctrl.isRevertibleActionSelected(item)"
                    class="btn btn-danger"
                    type="button"
                    ng-click="\$ctrl.revertAction(item)">
                    Revert
                  </button>
                  <button class="btn btn-primary action-button"
                          type="button"
                          ng-show="(item.status === 'PROCESSED' || item.status === 'REJECTED') && \$ctrl.isPrintActive(item)"
                          ng-click="\$ctrl.printValidation(item)">
                    Print validation
                  </button>
                </div>
              </inline-panel>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Empty report content -->
  <div class="empty-message" ng-if="\$ctrl.tableConfig.data.length == 0">
    <span>No data matching the given criteria exist</span>
  </div>

  <modal on-api-ready="\$ctrl.onModalApiReady" form="\$ctrl.modalForm">
    <modal-header><h2>Confirm revert</h2></modal-header>
    <modal-body>
      <ng-form name="\$ctrl.modalForm">

        <div class="labelled-field">
          <label>Remarks</label>
          <input ng-model="\$ctrl.revertRemarks" type="text" />
        </div>
      </ng-form>
    </modal-body>
  </modal>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/history/history-miscellaneous-transactions.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;